module.exports = {"220281001":"民主街道","220281002":"长安街道","220281003":"河南街道","220281004":"奶子山街道","220281005":"拉法街道","220281006":"河北街道","220281007":"新农街道","220281100":"新站镇","220281101":"天岗镇","220281102":"白石山镇","220281103":"漂河镇","220281104":"黄松甸镇","220281105":"天北镇","220281106":"松江镇","220281107":"庆岭镇","220281200":"乌林朝鲜族乡","220281201":"前进乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220281.json
// module id = 570
// module chunks = 0